const resource = 'v2/account/acquisition-survey'

export default $axios => ({
  get(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  submit(params) {
    return $axios.$post(`/${resource}`, params)
  },
  getServiceName: name => 'acquisitionSurveyService',
})
